import { useEffect } from "react";
import { Modal, ModalProps } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import CrossFailure from "../icon/CrossFailure";
import { getPortraitStageContainer } from "../PortraitStage";

interface FailureScanModalProps extends ModalProps {
  message?: string;
  onHide: () => void;
  redirectHomeAfterMs?: number;
}

const FailureScanModal = ({
  message,
  redirectHomeAfterMs = 5000,
  ...props
}: FailureScanModalProps) => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/");
    }, redirectHomeAfterMs);

    return () => clearTimeout(timer);
  }, [navigate, redirectHomeAfterMs]);

  return (
    <Modal
      container={getPortraitStageContainer}
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="commonModal"
    >
      <Modal.Body className="text-center" style={{ padding: 48 }}>
        <CrossFailure />
        <div className="loaderTxtScan">{message}</div>
      </Modal.Body>
    </Modal>
  );
};

export default FailureScanModal;
